import { UserApi } from '@/apis';
import RootStore from '.';
import BaseStore from './BaseStore';
import { User, UserResponse } from '@/types/user';
import { flow, makeObservable, observable } from 'mobx';
import { GetUsersRequest, GetUsersResponse } from '@/types/http-payload/user';
import { ResponseData } from '@/types/http';
import { TableState } from '@tanstack/react-table';

export default class UserStore extends BaseStore {
    users: User[] = [];
    userscombobox: any[] = [];
    user: any;
    api: UserApi;
    totalByRole: Object = {};

    constructor(rootStore: RootStore) {
        super(rootStore);
        makeObservable(this, {
            users: observable,
            userscombobox: observable,
            user: observable,
            totalByRole: observable,
            getUsers: flow.bound,
            getUsersCombobox: flow.bound,
            updateStatus: flow.bound,
            deleteUser: flow.bound,
            createUser: flow.bound,
            editUser: flow.bound,
            getUser: flow.bound
        });
        this.api = new UserApi();
    }

    *getUsers(searchParams: GetUsersRequest, paging?: TableState, isGetAll?: boolean) {
        try {
            const payload = { ...(!isGetAll ? this.convertPagingFromTableToRequest(paging ?? this.paging) : {}), ...searchParams };
            const res: ResponseData<GetUsersResponse> = yield this.rootStore.apiStore.call(this.api, this.api.getUsers, payload);
            if (res.ok) {
                this.users = res.data.elements;
                this.paging = {
                    ...this.paging,
                    sorting: paging?.sorting ?? [],
                    pagination: this.convertPaginationFromRequestToTable(res.data.pagination)
                };
                this.totalRecord = res.data.pagination.totalRecord;
                this.totalByRole = res.data.totalByRole;
            }
        } catch (error) {
            console.log(error);
        }
    }

    *getUsersCombobox(keySearch: string = '', size: number = 20, page: number = 1) {
        try {
            const res: ResponseData<any> = yield this.rootStore.apiStore.call(this.api, this.api.getUsersCombobox, { keySearch, size, page }, { hideLoading: true });
            if (res.ok) {
                this.userscombobox = res.data;
            }
        } catch (error) {
            console.log(error);
        }
    }

    *updateStatus(code: string, payload) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.updateStatus, { code, payload });
            if (res.ok) {
                return res;
            }
        } catch (error) {
            console.log(error);
        }
    }

    *deleteUser(code: string) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.deleteUser, code);
            if (res.ok) {
                return res;
            }
        } catch (error) {
            console.log(error);
        }
    }

    *createUser(payload) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.createUser, payload);
            if (res.ok) {
                return res;
            }
        } catch (error) {
            console.log(error);
        }
    }

    *getUser(code: string) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.getUser, code);
            if (res.ok) {
                this.user = res.data;
                return true;
            }
            return false;
        } catch (error) {
            console.log(error);
        }
    }

    *editUser(data) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.editUser, data);
            if (res.ok) {
                return res;
            }
        } catch (error) {
            console.log(error);
        }
    }

    clean(): void {
        super.clean();
        this.users = [];
    }
}
